<template>
    <div class="card mb-5" >
        <div class="card-body">
            <div class="titles">
                <h5 class="card-title">{{ blog.name }}</h5>
                <h5 class="card-title">{{ blog.generatedUrl }}</h5>
            </div>
            <div class="logo">
                <img src="@/assets/img/icons/stpaketlogo2.png" alt="" />
            </div>
            <!-- <p class="card-title">{{ blog.currentPost }}</p>
            <p>{{ blog.createdAt }}</p> -->
        </div>
        <div class="card-btn">
            <button type="button" class="btn btn-warning btn-round" @click ="$emit('update' , blog)">Update</button>
        </div>
    </div>
</template>
<script>
// import axios from 'axios'
import APIs from './../../../../config'
export default {
    name : "BlogCard",
    data(){
        return {
            imgUrl : APIs.API_IMAGES,
        }
    },
    props : {
        blog : Object
    },
    methods : {

    }
}
</script>
<style scoped lang="scss">
    @import url('https://fonts.googleapis.com/css2?family=Poppins:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');

    $main_font: 'Poppins', sans-serif;

    .card {
        height: 250px;
        &:hover {
            .card-btn {
                button {
                    opacity: 1;
                }
            }
        }
        .card-body {
            display: flex;
            justify-content: space-between;
            .titles {
                font-family: $main_font;
                h5 {
                    &:first-of-type {
                        font-weight: 600;
                        font-size: 30px;
                    }
                    &:last-of-type {
                        font-weight: 500;
                    }
                }
            }
            .logo {
                img {
                    width: 80%;
                }
            }
        }
        .card-btn {
            display: flex;
            justify-content: space-around;
            button {
                width: 30%;
                opacity: 0;
                transition: all .3s ease-in-out;
            }
        }
    }
    .card-img-top {
        object-fit: cover;
    }
    .descreption {
        font-family: "Poppins", sans-serif;
        color: #005E6E;
        font-weight: 300;
        white-space: pre-wrap;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
    }
</style>
